import { render } from "./partC.vue?vue&type=template&id=0600e770"
import script from "./partC.vue?vue&type=script&lang=js"
export * from "./partC.vue?vue&type=script&lang=js"

import "./partC.vue?vue&type=style&index=0&id=0600e770&lang=css"

import exportComponent from "C:\\WorkSpace\\webapp\\vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__